<div class="flex h-full min-h-0 w-full flex-col overflow-y-auto scrollbar-transparent">
  <div class="shrink-0 p-4">
    <admin-payout-trace-checklist #traceChecklist (traceCompleted)="onTraceCompleted($event)" />
  </div>

  @if (traceResult()) {
  <div class="shrink-0 border-t border-zinc-200 p-4 dark:border-zinc-800">
    @if (showRetry()) {
    <div class="space-y-4">
      <div>
        <h4 class="text-sm font-semibold text-primary">Retry payout</h4>
        <p class="mt-1 text-xs text-secondary">
          Payout record found. Triggers <code class="text-primary">POST /payouts/:id/retry</code>.
        </p>
      </div>

      <div class="w-full space-y-2">
        <label for="payout-retry-id" class="block text-sm font-medium text-primary">Payout ID</label>
        <input
          id="payout-retry-id"
          type="text"
          autocomplete="off"
          class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
          [value]="payoutId()"
          (input)="onPayoutIdInput($any($event.target).value)"
          [disabled]="actionLoading()"
        />
      </div>

      <button
        type="button"
        class="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
        (click)="runRetry()"
        [disabled]="actionLoading() || !payoutId().trim()"
      >
        @if (actionLoading()) {
          Retrying…
        } @else {
          Retry payout
        }
      </button>
    </div>
    } @else if (showCreate()) {
    <div class="space-y-4">
      <div>
        <h4 class="text-sm font-semibold text-primary">Create payout</h4>
        <p class="mt-1 text-xs text-secondary">
          No payout on this wallet transaction. Submits <code class="text-primary">POST /payouts</code> with the
          fields below (amounts in minor units, e.g. pence/cents).
        </p>
      </div>

      <form
        class="grid w-full gap-4 sm:grid-cols-2"
        (submit)="$event.preventDefault(); runCreate()"
        [attr.aria-disabled]="actionLoading()"
      >
        <fieldset class="contents" [disabled]="actionLoading()">
        <div class="space-y-1 sm:col-span-2">
          <label for="create-creator-id" class="block text-sm font-medium text-primary">Creator ID</label>
          <input
            id="create-creator-id"
            type="text"
            autocomplete="off"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.blazeFirebaseUid"
          />
        </div>

        <div class="space-y-1 sm:col-span-2">
          <label for="create-brief-app-id" class="block text-sm font-medium text-primary">Brief application ID</label>
          <input
            id="create-brief-app-id"
            type="text"
            autocomplete="off"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.briefApplicationId"
          />
        </div>

        <div class="space-y-1">
          <label for="create-currency" class="block text-sm font-medium text-primary">Currency</label>
          <input
            id="create-currency"
            type="text"
            autocomplete="off"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.currencyCode"
          />
        </div>

        <div class="space-y-1">
          <label for="create-brief-currency" class="block text-sm font-medium text-primary">Brief currency</label>
          <input
            id="create-brief-currency"
            type="text"
            autocomplete="off"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.briefCurrencyCode"
          />
        </div>

        <div class="space-y-1">
          <label for="create-provider" class="block text-sm font-medium text-primary">Provider</label>
          <select
            id="create-provider"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.provider"
          >
            @for (provider of providerOptions; track provider) {
            <option [value]="provider">{{ provider }}</option>
            }
          </select>
        </div>

        <div class="space-y-1">
          <label for="create-wallet-tx-id" class="block text-sm font-medium text-primary">Wallet transaction ID</label>
          <input
            id="create-wallet-tx-id"
            type="text"
            autocomplete="off"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.walletTransactionId"
          />
        </div>

        <div class="space-y-1">
          <label for="create-amount" class="block text-sm font-medium text-primary">Amount (minor units)</label>
          <input
            id="create-amount"
            type="number"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.amount"
          />
        </div>

        <div class="space-y-1">
          <label for="create-brief-amount" class="block text-sm font-medium text-primary">Brief amount (minor units)</label>
          <input
            id="create-brief-amount"
            type="number"
            class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
            [formField]="createPayoutForm.briefAmount"
          />
        </div>

        <div class="flex flex-row items-center gap-3 sm:col-span-2">
          <button
            type="submit"
            class="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
            [disabled]="actionLoading()"
          >
            @if (actionLoading()) {
              Creating…
            } @else {
              Create payout
            }
          </button>
        </div>
        </fieldset>
      </form>
    </div>
    }
  </div>
  }
</div>
